// Top-level route table. Auth state lives here so a single useAuth instance
// drives both the login form and the protected gate.
//
// P0 Pau (07-09 20:3xZ): la oficina pixel/Habbo (OfficePage, /office) queda
// eliminada de la app -- "lo he dicho 50 veces, se tira a la basura". /office
// redirige a /oficina (cliente, y 301 real de servidor en app.ts). La landing
// tras login es /oficina; el dashboard clasico de gestion de agentes sigue
// vivo en /home por si hace falta para operar la flota, pero deja de ser la
// portada.

import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { useAutoMarkReadOnVisibility } from './hooks/useAutoMarkReadOnVisibility';
import { LoginPage } from './pages/LoginPage';
import { AltaPage } from './pages/AltaPage';
import { CuentasPage } from './pages/CuentasPage';
import { HomePage } from './pages/HomePage';
import { SettingsPage } from './pages/SettingsPage';
import { OficinaPage } from './features/oficina/OficinaPage';
import { SocketRaiz } from './features/oficina/SocketRaiz';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AvisoVersionNueva } from './components/AvisoVersionNueva';

export function App() {
  const { authState, login, loginCodigo, contrasenaCompartida, logout } = useAuth();
  useAutoMarkReadOnVisibility();

  return (
    <>
    {authState === 'authed' ? <SocketRaiz /> : null}
    {authState === 'authed' ? <AvisoVersionNueva /> : null}
    <Routes>
      <Route
        path="/login"
        element={<LoginPage authed={authState === 'authed'} login={login} loginCodigo={loginCodigo} contrasenaCompartida={contrasenaCompartida} />}
      />
      {/* Alta de una cuenta personal desde su enlace (pública: el enlace es la llave). */}
      <Route path="/alta" element={<AltaPage />} />
      <Route
        path="/cuentas"
        element={
          <ProtectedRoute authState={authState}>
            <CuentasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={<Navigate to="/oficina" replace />}
      />
      <Route
        path="/home"
        element={
          <ProtectedRoute authState={authState}>
            <HomePage logout={logout} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute authState={authState}>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route path="/office" element={<Navigate to="/oficina" replace />} />
      <Route
        path="/oficina"
        element={
          <ProtectedRoute authState={authState}>
            <OficinaPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/oficina" replace />} />
    </Routes>
    </>
  );
}
